import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/offer';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById('hero-cta');
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-37" data-mp="bq9furzo3c1a">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" data-id="element-38" data-mp="195wrtb2xzn8w">
          <div className="mx-auto max-w-md" data-id="element-39" data-mp="2f40yg72i4po2">
            <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2 rounded-2xl border-2 border-navy bg-gold px-4 py-4 font-display text-base font-extrabold uppercase text-navy shadow-[0_6px_0_#B98400,0_12px_30px_rgba(10,27,51,0.35)] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 sm:text-lg" data-id="element-40" data-mp="2f2r2bnf7lrk2">
              <span className="whitespace-nowrap" data-id="element-41" data-mp="1wec9culc03gm">Get the Blueprint · $27</span>
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-42" data-mp="1iejp9i4b8lhm" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}